<template>
    <CRow>
        <CCol sm="6" lg="3">
            <CWidgetDropdown color="primary" :header="formatMoney(data.cart_revenues.datasets.price)" :text="data.cart_revenues.datasets.label">
                <template #default>
                    <CIcon :content="$options.iconsSet.cilMoney" height="52"/>
                </template>
                <template #footer>
                    <CChartLineSimple
                            pointed
                            class="mt-3 mx-3"
                            style="height:70px"
                            :data-points="data.cart_revenues.datasets.data"
                            point-hover-background-color="primary"
                            label=" ریال"
                            :labels="data.cart_revenues.labels"
                    />
                </template>
            </CWidgetDropdown>
        </CCol>
        <CCol sm="6" lg="3">
            <CWidgetDropdown color="info" :header="formatMoney(data.cart_payments.datasets.price)" :text="data.cart_payments.datasets.label">
                <template #default>
                    <CIcon :content="$options.iconsSet.cilBasket" height="52"/>
                </template>
                <template #footer>
                    <CChartLineSimple
                            pointed
                            class="mt-3 mx-3"
                            style="height:70px"
                            :data-points="data.cart_payments.datasets.data"
                            point-hover-background-color="info"
                            :options="{ elements: { line: { tension: 0.00001 }}}"
                            label=" ریال"
                            :labels="data.cart_payments.labels"
                    />
                </template>
            </CWidgetDropdown>
        </CCol>
        <CCol sm="6" lg="3">
            <CWidgetDropdown
                    color="warning"
                    :header="formatMoney(data.cart_invoices_count.datasets.price)"
                    :text="data.cart_invoices_count.datasets.label"
            >
                <template #default>
                    <CIcon :content="$options.iconsSet.cilIndentDecrease" height="52"/>
                </template>
                <template #footer>
                    <CChartLineSimple
                            class="mt-3"
                            style="height:70px"
                            background-color="rgba(255,255,255,.2)"
                            :data-points="data.cart_invoices_count.datasets.data"
                            :options="{ elements: { line: { borderWidth: 2.5 }}}"
                            point-hover-background-color="warning"
                            label="فاکتور"
                            :labels="data.cart_invoices_count.labels"
                    />
                </template>
            </CWidgetDropdown>
        </CCol>
        <CCol sm="6" lg="3">
            <CWidgetDropdown
                    color="danger"
                    :header="formatMoney(data.cart_bills_count.datasets.price)"
                    :text="data.cart_bills_count.datasets.label">
                <template #default>
                    <CIcon :content="$options.iconsSet.cilIndentIncrease" height="52"/>
                </template>
                <template #footer>
                    <CChartLineSimple
                            class="mt-3"
                            style="height:70px"
                            background-color="rgb(250, 152, 152)"
                            :data-points="data.cart_bills_count.datasets.data"
                            :options="{ elements: { line: { borderWidth: 2.5 }}}"
                            point-hover-background-color="warning"
                            label="فاکتور"
                            :labels="data.cart_bills_count.labels"
                    />
                </template>
            </CWidgetDropdown>
        </CCol>
    </CRow>
</template>

<script>
    import {CChartLineSimple, CChartBarSimple} from '../charts/index.js'
    import {iconsSet} from '../../assets/icons/icons'

    export default {
        name: 'WidgetsDropdown',
        props: ['data'],
        iconsSet,
        components: {CChartLineSimple, CChartBarSimple},
        methods: {
            formatMoney(amount, decimalCount = 0, decimal = "", thousands = ",") {
                try {
                    decimalCount = Math.abs(decimalCount);
                    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

                    const negativeSign = amount < 0 ? "-" : "";

                    let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
                    let j = (i.length > 3) ? i.length % 3 : 0;

                    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
                } catch (e) {
                    console.log(e)
                }
            }
        }
    }
</script>
